updateQueries_1